import asyncEachLimit from 'async/eachLimit';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  getVolumeDirList,
  fetchVolumeDir,
  requestDownload,
  undelete,
  undeleteList,
  getMedia,
  findMedia,
  addMedia,
};

let g_mediaListMap: any = {};

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done && done();
}
function isReady() {
  return true;
}
function getVolumeDirList(volume_id: number, path: string) {
  const key = `${volume_id}-${path}`;
  return g_mediaListMap[key];
}
function fetchVolumeDir(params: any, done?: any) {
  const { volume_id, path } = params;
  const opts = {
    url: `/api/1/media/dir`,
    query: {
      volume_id,
      prefix_path: path,
    },
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('MediaStore.fetchVolumeDir: err:', err, body);
    } else {
      const key = `${volume_id}-${path}`;
      g_mediaListMap[key] = body;
      _emit('update_dir');
    }
    if (done) {
      done(err, body);
    }
  });
}
function requestDownload(params: any, done: (err: string | null) => void) {
  const { volume_id, media_id } = params;
  const opts = {
    url: `/api/1/media/${media_id}/download?volume_id=${volume_id}`,
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('MediaStore.requestDownload: err:', err, body);
    }
    done(err);
  });
}
function undelete(params: any, done: (err: string | null) => void) {
  const { volume_id, media_id } = params;
  const opts = {
    url: `/api/1/media/${media_id}/undelete`,
    query: {
      volume_id,
    },
    body: {
      is_deleted: 0,
    },
  };
  UserStore.post(opts, (err, body) => {
    if (err) {
      util.errorLog('MediaStore.undelete: err:', err, body);
    }
    done(err);
  });
}
function undeleteList(params: any, done: (err: string | null) => void) {
  const { volume_id, media_list, on_progress } = params;

  const total = media_list.length;
  let count = 0;
  asyncEachLimit(
    media_list,
    5,
    (media, done) => {
      undelete({ volume_id, media_id: media.media_id }, (err) => {
        if (!err) {
          count++;
          on_progress({ count, total });
        }
        done(err);
      });
    },
    done
  );
}
function getMedia(params, done) {
  const { volume_id, media_id } = params;
  const opts = {
    url: `/api/1/media/${media_id}`,
    query: {
      volume_id,
    },
  };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('MediaStore.getMedia: err:', err, body);
    }
    done(err, body);
  });
}
function findMedia(params, done) {
  const { volume_id, media_path } = params;
  const opts = {
    url: '/api/1/media/find',
    query: {
      volume_id,
      media_path,
    },
    retry: true,
  };
  UserStore.get(opts, (err, body) => {
    console.log('find:', err, body);
    let media;
    if (err === 404) {
      err = null;
    } else if (!err) {
      media = _fixupMedia(body);
    }
    done(err, media);
  });
}
function addMedia(params, done) {
  const { volume_id, media_path, file_size, file_hash, ctime, mtime } = params;
  const opts = {
    url: `/api/1/media`,
    query: {
      volume_id,
    },
    body: {
      media_path,
      file_size,
      file_hash,
      ctime: new Date(ctime),
      mtime: new Date(mtime),
    },
    retry: true,
  };
  UserStore.post(opts, (err, body) => {
    let media;
    if (!err) {
      media = {
        media_id: body.media_id,
        media_path,
        file_size,
        file_hash,
        ctime,
        mtime,
      };
    }
    done(err, media);
  });
}
function _fixupMedia(body) {
  if (body && body.mtime) {
    body.mtime = Date.parse(body.mtime);
  }
  return body;
}
